import { cn } from '@/lib/utils';
import { stageStyles } from '@/data/stageConfig';
import { useTranslation } from 'react-i18next';

interface StageBadgeProps {
  stage: string;
  className?: string;
}

export function StageBadge({ stage, className }: StageBadgeProps) {
  const { t } = useTranslation();

  return (
    <span
      className={cn(
        'inline-flex items-center px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider',
        stageStyles[stage] || 'bg-foreground/10 text-foreground',
        className
      )}
    >
      {t(`stages.${stage}`, { defaultValue: stage })}
    </span>
  );
}
